export default __webpack_public_path__ + "static/media/icones_meu_plano.1309b19c.svg";